import React from 'react';
import { Button } from 'antd';

export default class CartButton extends React.Component {
	render() {
		return (
			<Button
				type="primary"
				disabled={this.props.inCart || this.props.inBooking || this.props.outOfStock || this.props.programDeadlinePassed}
				onClick={this.props.onClick}
				icon="shopping-cart"
				size={this.props.buttonSize ? this.props.buttonSize : "default"}>
				{
					(this.props.inBooking) ? 'Registered' :
					(this.props.inCart) ? 'In Cart' :
					(this.props.outOfStock)? 'Sold Out' :
					'Add to Cart'
				}
			</Button>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/FieldPrograms/ProgramCardList/CartButton.jsx